import { Grid, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLiveEnabled } from "@/partner/entities/instance";
import { FilterProvider, Filter } from "@/partner/shared/components/Filter";
import { FilterTabs } from "@/partner/shared/components/FilterTabs";
import { LazyAnalyticsWidget } from "@/partner/shared/components/LazyAnalyticsWidget";
import { getAnalyticsTabs } from "./analyticsTabs";
import { AnalyticsViewsMetrics } from "./AnalyticsViewsMetrics";
import { AnalyticsViewsByDateChart } from "./AnalyticsViewsByDateChart";
import { AnalyticsVisitorsByDateChart } from "./AnalyticsVisitorsByDateChart";
import { AnalyticsDurationByDateChart } from "./AnalyticsDurationByDateChart";
import { AnalyticsViewsByContentTable } from "./AnalyticsViewsByContentTable";
import { AnalyticsViewsByTagTable } from "./AnalyticsViewsByTagTable";
import { AnalyticsViewsByCountryMap } from "./AnalyticsViewsByCountryMap";
import { AnalyticsViewsByCountryTable } from "./AnalyticsViewsByCountryTable";
import { AnalyticsViewsByCityTable } from "./AnalyticsViewsByCityTable";
import { AnalyticsViewsByDeviceTypeTable } from "./AnalyticsViewsByDeviceTypeTable";
import { AnalyticsViewsByDeviceOsTable } from "./AnalyticsViewsByDeviceOsTable";
import { AnalyticsViewsByUtmTable } from "./AnalyticsViewsByUtmTable";
import { AnalyticsViewsByLinkTable } from "./AnalyticsViewsByLinkTable";
import { AnalyticsViewsByEmailCampaignTable } from "./AnalyticsViewsByEmailCampaignTable";

function AnalyticsViewsTabContent() {
  const { t } = useTranslation();
  const liveEnabled = useLiveEnabled();

  return (
    <Stack spacing={1}>
      <Filter
        title={t("analytics.pageTitle")}
        dateChips="RELATIVE"
        // Тип «эфир» в фильтре только там, где эфиры включены: на
        // adult-инстансе такого контента не бывает.
        hideStreamContentType={!liveEnabled}
        fields={{
          contentIds: true,
          tagIds: true,
          contentTypes: true,
          countryCodes: true,
          creatorIds: true,
          dateFrom: true,
          dateTo: true,
          userDeviceTypes: true,
          userDeviceOss: true,
          linkIds: true,
          utmSources: true,
          utmMediums: true,
          utmCampaigns: true,
          utmContents: true,
          utmTerms: true,
          emailAutomationIds: true,
        }}
      />

      <FilterTabs value="views" tabs={getAnalyticsTabs(t)} />

      <AnalyticsViewsMetrics />

      <Grid container spacing={1}>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByDateChart />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsVisitorsByDateChart />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsDurationByDateChart />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByContentTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByTagTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByCountryMap />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByCountryTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByCityTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByDeviceTypeTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByDeviceOsTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByUtmTable
              dimension="SOURCE"
              title={t("analytics.views.tableByUtmSource")}
            />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByUtmTable
              dimension="MEDIUM"
              title={t("analytics.views.tableByUtmMedium")}
            />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByUtmTable
              dimension="CAMPAIGN"
              title={t("analytics.views.tableByUtmCampaign")}
            />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByUtmTable
              dimension="CONTENT"
              title={t("analytics.views.tableByUtmContent")}
            />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByUtmTable
              dimension="TERM"
              title={t("analytics.views.tableByUtmTerm")}
            />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByLinkTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsViewsByEmailCampaignTable />
          </LazyAnalyticsWidget>
        </Grid>
      </Grid>
    </Stack>
  );
}

export function AnalyticsViewsTab() {
  return (
    <FilterProvider initialPeriod="month">
      <AnalyticsViewsTabContent />
    </FilterProvider>
  );
}
